import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Every radio tag and category, with how many non-deleted shows use each.
const GET_RADIO_TAGS = gql`
  query getRadioTags {
    getRadioTags {
      isAuth
      tags { id name { es ca en pt } isCategory usage }
    }
  }
`;

const getRadioTags = async () => {
  try {
    const result = await client
      .query({
        query: GET_RADIO_TAGS,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getRadioTags: getRadioTagsData },
    } = result;

    if (getRadioTagsData) {
      return getRadioTagsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getRadioTags = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getRadioTags Error: ${error}`);
    return null;
  }
};

export default getRadioTags;
